import * as React from 'react';
import { RootStore, withInjectedRootStore } from '../../providers';
import classNames from 'classnames';
import s from './CheckoutSummaryFooter.scss';
import { Translation } from 'react-i18next';
import { Text } from '@wix/design-system';

const CheckoutSummaryFooterComp: React.FC<{ rootStore: RootStore }> = ({
  rootStore,
}) => {
  const { isSecondUpgrade, isChangePlan } = rootStore.appStore;
  return (
    <Translation>
      {(t) => (
        <>
          {!isSecondUpgrade && !isChangePlan && (
            <div
              className={classNames(s.subDisclaimer, s.guarantee)}
              data-testid='checkout-money-back'
            >
              <div className={s.iconWrapper}>
                <div className={s.moneyBack} />
              </div>
              <Text size='medium' weight='normal'>
                {t('checkout.money_back_guarantee')}
              </Text>
            </div>
          )}
        </>
      )}
    </Translation>
  );
};

export const CheckoutSummaryFooter = withInjectedRootStore(
  CheckoutSummaryFooterComp,
);
